import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { User, Lock, AlertCircle } from 'lucide-react';
export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await login(username, password);
      if (success) {
        navigate('/');
      } else {
        setError('Invalid username or password');
      }
    } catch (err) {
      setError('An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="flex min-h-screen bg-gray-50" data-id="element-92">
      <div className="m-auto w-full max-w-md p-8 bg-white rounded-lg shadow-md" data-id="element-93">
        <div className="text-center mb-8" data-id="element-94">
          <img src="https://dwaami.sbaapp.net/images/dwaami.png" alt="Logo" className="h-12 mx-auto mb-4" data-id="element-95" />
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-96">
            Committee Management Platform
          </h1>
          <p className="text-gray-600 mt-2" data-id="element-97">Login to your account</p>
        </div>
        {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md flex items-center text-red-700" data-id="element-98">
            <AlertCircle size={18} className="mr-2" data-id="element-99" />
            {error}
          </div>}
        <form onSubmit={handleSubmit} data-id="element-100">
          <div className="space-y-4" data-id="element-101">
            <div data-id="element-102">
              <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-103">
                Username
              </label>
              <div className="relative" data-id="element-104">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-105">
                  <User size={18} className="text-gray-400" data-id="element-106" />
                </div>
                <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="Enter your username" required data-id="element-107" />
              </div>
            </div>
            <div data-id="element-108">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-109">
                Password
              </label>
              <div className="relative" data-id="element-110">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-111">
                  <Lock size={18} className="text-gray-400" data-id="element-112" />
                </div>
                <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" placeholder="Enter your password" required data-id="element-113" />
              </div>
            </div>
            <div className="flex items-center justify-between" data-id="element-114">
              <div className="flex items-center" data-id="element-115">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded" data-id="element-116" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700" data-id="element-117">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-118">
                <a href="#" className="text-orange-500 hover:text-orange-600" data-id="element-119">
                  Forgot password?
                </a>
              </div>
            </div>
            <div data-id="element-120">
              <button type="submit" disabled={isLoading} className="w-full py-2 px-4 bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors" data-id="element-121">
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>;
}